import React, { useEffect, useMemo, useState } from 'react'
import FinancialKPIButton from '../../ui/FinancialKPIData/FinancialKPIButtonWithExternalLabel'
import SelectWithExternalLabel from '../../ui/SelectWithExternalLabel'
import ScreenerFiltersChange from './ScreenerFiltersChange'
import { DatasetProvider, useDataset } from '../../../context/dataset'
import useScreenerFilters from '../hooks/useScreenerFilters'
import { useScreenerContext } from '../context/useScreenerContext'
import { Autocomplete, TextField, IconButton, Typography } from '@mui/material'
import { getColumnsOfDatasets as getColumns} from '../../../utils/tools'
import { ClearSharp }from '@mui/icons-material'
import styles from './ScreenerFiltersModal.module.scss'

import AutocomplateButton from '../../ui/AutocomplateButton'
import SelectButton from '../../ui/FinancialKPIData/SelectButton'
import ButtonActive from '../../ui/Button'

export default function SectionFinancialKPIData({dataset, FinancialKPIsOptions}) {
    const { addFinancialKPIData,removeFinancialKPIData, handleUpdateDataset, handleFinancileKPISelect, updateTopBottomLimitOnOptions,removeTopBottomLimitsOnOptions ,updateTopBottomLimitOn} = useScreenerContext()
    const limit = 1
    const container = useMemo(() => dataset.map(
        (_, index) => {
            const props = { dataset, index, handleUpdateDataset, getColumns, key:`${dataset[index]?.datasetValue}-${index}`}
            return <DatasetProvider {...props}>
                    <Dataset {...props} handleUpdateSelect={handleFinancileKPISelect} currentDataset={dataset[index]} FinancialKPIsOptions={FinancialKPIsOptions} removeFinancialKPIData={removeFinancialKPIData} updateTopBottomLimitOnOptions={updateTopBottomLimitOnOptions}updateTopBottomLimitOn = {updateTopBottomLimitOn} removeTopBottomLimitsOnOptions={removeTopBottomLimitsOnOptions} />
                </DatasetProvider>
            }
    ),[dataset, handleUpdateDataset]) // eslint-disable-line

    return (
        <div className={styles['alterantive-data-container']}>
            {container}
            {dataset.length < limit && <Typography onClick={addFinancialKPIData} classes={{root: styles['add-data']}}>+ Add Financial KPI Data</Typography>}
        </div>

    )
}


const Dataset = ({index, currentDataset, handleUpdateSelect,FinancialKPIsOptions,updateTopBottomLimitOn,updateTopBottomLimitOnOptions,removeTopBottomLimitsOnOptions, TopBottomLimitOPtions,removeFinancialKPIData, ...props}) => {
    const [selectedKPI, setSelectedKPI] = useState(currentDataset['KPI'])
    // const { columns , changeColumn, datasets, changeDataset, removeDataset, originalFrequency } = useDataset()
    const { selectRole, selectTimePeriod, defaultFrequency } = useScreenerFilters('daily')
    // const btnProps = {columns , changeColumn, datasets, changeDataset, currentDataset, FinancialKPIsOptions}

    useEffect(() => {(defaultFrequency && !currentDataset.forTimeperiod) && handleUpdateSelect({name:'forTimeperiod',value: defaultFrequency}, index);return () => {}}
        ,[defaultFrequency, currentDataset.forTimeperiod, handleUpdateSelect, index, selectTimePeriod])

    const updateSelect = (data) => handleUpdateSelect(data, index)

    const removeFinancialKPI = (index) =>{
        removeFinancialKPIData(index);
        removeTopBottomLimitsOnOptions('price')
    }

    return (
        <div id={`${index}-financial-kpi-data`} className={styles['alternative-data-fields']}>
            <div className={styles['limit-size']}>
                <Autocomplete
                    size='small'
                    disablePortal
                    id="combo-box-demo"
                    value={selectedKPI}
                    // setValue={updateSelect}
                    options={FinancialKPIsOptions}
                    renderInput={(params) => <TextField {...params} label='Choose a Financial KPI' />}
                    onChange={(e,v)=>{
                        updateSelect({name:'KPI',value:v?v['label']:''});setSelectedKPI(v);
                        if (v){
                            updateTopBottomLimitOnOptions([{'label':'Price','value':'price'}])
                        }
                        else{
                            removeTopBottomLimitsOnOptions('price')
                        }
                    }}            
                />
            </div>
            <SelectWithExternalLabel label='Role' options={selectRole} value={currentDataset.rule} setValue={updateSelect} fieldName='rule'/>
            <div className={styles['change']}>
                <ScreenerFiltersChange label='change' rule={currentDataset.rule} value={currentDataset.change} setValue={updateSelect} fieldName='change'/>
            </div>  
            <SelectWithExternalLabel label='For Timeperiod' options={selectTimePeriod} value={currentDataset.forTimeperiod || defaultFrequency} setValue={updateSelect} fieldName='forTimeperiod'/>
            <IconButton onClick={()=>{removeFinancialKPI(index);updateTopBottomLimitOn({'label':'','value':''})}}  classes={{root: styles['remove-btn']}}>
            <ClearSharp/>
            </IconButton>

        </div>
       
    )
}

